import React from "react";

const Twitter = ({
  width = 24,
  height = 24,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.6541 4.6875H19.1351L13.7148 10.8825L20.0913 19.3125H15.0986L11.1881 14.1997L6.71362 19.3125H4.23112L10.0286 12.6862L3.91162 4.6875H9.03112L12.5658 9.36075L16.6541 4.6875ZM15.7833 17.8275H17.1581L8.28412 6.0945H6.80887L15.7833 17.8275Z"
        fill="#FAFAFA"
      />
    </svg>
  );
};

export default Twitter;
